export { default } from './PlayerDetailsModal';
